/**
 * Formata createdAt ISO para exibição pt-BR.
 * @param {string|null|undefined} iso
 * @returns {string}
 */
export function formatNotificationCreatedAt(iso) {
  if (typeof iso !== "string" || !iso.trim()) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  const day = date.toLocaleDateString("pt-BR", { day: "2-digit" });
  const month = date
    .toLocaleDateString("pt-BR", { month: "short" })
    .replace(".", "")
    .trim();
  const year = date.toLocaleDateString("pt-BR", { year: "numeric" });
  const time = date.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${day} ${month} ${year}, ${time}`;
}

/**
 * @param {Object} [notification]
 * @returns {boolean}
 */
export function isNotificationUnread(notification) {
  if (!notification) return false;
  if (notification.status === "read") return false;
  if (typeof notification.readAt === "string" && notification.readAt.trim()) {
    return false;
  }
  return true;
}
